import { render } from "./PanelTipsterEfectividadDesc.vue?vue&type=template&id=79fa0df9&scoped=true"
import script from "./PanelTipsterEfectividadDesc.vue?vue&type=script&lang=js"
export * from "./PanelTipsterEfectividadDesc.vue?vue&type=script&lang=js"

import "./PanelTipsterEfectividadDesc.vue?vue&type=style&index=0&id=79fa0df9&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79fa0df9"]])

export default __exports__